import styled from 'styled-components';

export const Container = styled.div`
  width: 320px;
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px;
  margin: 4px 28px;
  background: rgba(196, 196, 196, 0.1);

  @media (max-width: 375px) {
    margin: 8px 0px;
    width: 100%;
    height: auto;
  }

  strong {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    margin: 22px 0;
  }
  p {
    text-align: center;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
  }
`;
